var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"STUDENT PORTAL","title":"Exam","description":"Open available examinations and student exam tools.","count-label":"exam tools"}},[_c('Submenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }